import { render, staticRenderFns } from "./Index.vue?vue&type=template&id=6ad2e226&scoped=true"
import script from "./Index.vue?vue&type=script&lang=js"
export * from "./Index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ad2e226",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/mahalo_integrador/hiopos/reports-co/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6ad2e226')) {
      api.createRecord('6ad2e226', component.options)
    } else {
      api.reload('6ad2e226', component.options)
    }
    module.hot.accept("./Index.vue?vue&type=template&id=6ad2e226&scoped=true", function () {
      api.rerender('6ad2e226', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/layouts/horizontal/Index.vue"
export default component.exports